import { render, staticRenderFns } from "./EmailChange.vue?vue&type=template&id=287e2145&"
import script from "./EmailChange.vue?vue&type=script&lang=js&"
export * from "./EmailChange.vue?vue&type=script&lang=js&"
import style0 from "./EmailChange.vue?vue&type=style&index=0&id=287e2145&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports